import React, { useState, useEffect } from 'react';
import { spotlightAPI } from '../services/api';
import { getProfilePicture } from '../utils/helpers';
import { Link } from 'react-router-dom';

const Spotlight = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSpotlight();
  }, []);

  const fetchSpotlight = async () => {
    try {
      console.log('Spotlight: Fetching spotlight data');
      const response = await spotlightAPI.getSpotlight();
      console.log('Spotlight: Response received:', response);

      // Handle different response formats
      let usersData = [];
      if (response.data?.users) {
        usersData = response.data.users;
      } else if (response.data && Array.isArray(response.data)) {
        usersData = response.data;
      } else if (response.data && typeof response.data === 'object') {
        // Maybe users are in a different property
        usersData = Object.values(response.data).filter(item => typeof item === 'object' && item.id);
      }

      console.log('Spotlight: Processed users data:', usersData);
      setUsers(usersData);
    } catch (error) {
      console.error('Failed to fetch spotlight:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        status: error.response?.status
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading || users.length === 0) {
    return null;
  }

  return (
    <div className="spotlight-container well bg-white">
      <div className="spotlight-inner">
        <ul className="spotlight">
          {users.map((user) => (
            <li key={user.id}>
              <Link to={`/user/${user.id}`}>
                <img
                  src={getProfilePicture(user)}
                  alt={user.full_name}
                  className="spotlight-image img-circle"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Spotlight;

